import type { ScanServiceType, UnisonProjectTypeId } from '@witmetrics/utils';
import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';
import type { BlockSettings } from '@/dialogs/NewCaseDialog/types';

export const classes = {
  scansBlock: 'grid grid-cols-2 gap-4 mt-6',
  photosBlock: 'grid grid-cols-2 gap-4 mt-4',
  titleWrapper: 'w-full grid grid-cols-1 gap-4',
  condensed: 'grid-cols-2',
  photosToggle: 'w-1/2',
  section: 'm-4 mt-6',
};

export function getBlocks(serviceType?: ScanServiceType): BlockSettings[] {
  return [
    {
      fileType: serviceType ? 'RELU_UPPER_ARCH' : 'UPPER_ARCH',
      title: 'Scan',
      subtitle: 'Upper',
    },
    {
      fileType: serviceType ? 'RELU_LOWER_ARCH' : 'LOWER_ARCH',
      title: 'Scan',
      subtitle: 'Lower',
    },
  ];
}

export function getSubtitle(projectTypeId: UnisonProjectTypeId) {
  return projectTypeId === UNISON_PROJECT_TYPE_ID.NIGHTGUARD
    ? 'Include scans for both upper & lower arches'
    : 'Include a scan of at least one arch';
}
